import { useIsPlayerActive } from "../hooks/useIsPlayerActive"

/**
 * Hook that returns style object for PageStyle.rootElStyle with conditional padding
 * for when the UniversalPlayer is active. Use this instead of just importing the CSS
 * class when you need the dynamic padding behavior.
 *
 * @returns {Object} Style object with paddingBottom conditionally set
 */
export const usePageStyleWithPlayer = () => {
  const isPlayerActive = useIsPlayerActive()

  return {
    paddingBottom: isPlayerActive ? "100px" : undefined,
  }
}
